var map = {
	"./Component": 9866,
	"./Component.js": 9866,
	"./Link/CV.png": 5135,
	"./Link/cf.png": 4077,
	"./Link/lc.png": 3852,
	"./Other/achieveiiitd.png": 4773,
	"./Other/acm.png": 4824,
	"./Other/wagtail.png": 6270,
	"./Project/ll.png": 9929,
	"./Project/shoppr.png": 5550,
	"./Project/tank-star.png": 7574,
	"./Tech/JS.png": 1472,
	"./Tech/React.png": 2292,
	"./Tech/c.png": 2495,
	"./Tech/cpp.png": 7450,
	"./Tech/express.png": 3880,
	"./Tech/git.png": 1769,
	"./Tech/java.png": 9784,
	"./Tech/mongoDB.png": 1003,
	"./Tech/mysql.png": 504,
	"./Tech/node.png": 4042,
	"./Tech/python.png": 862,
	"./Tech/tailwind.png": 7577,
	"./Tech/ts.png": 6535,
	"./Work": 4647,
	"./Work.js": 4647,
	"./back.png": 7568
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6259;